// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  // apiUrl: 'http://192.168.1.10:8081/SelfPatentPortal',//Testing
  // apiUrl: 'https://ipatapp.dexpatent.com/SelfPatentPortal', //Local
  apiUrl: 'https://ipatappserver.dexpatent.com/SelfPatentPortal', //Local
  //  apiUrl: 'http://35.165.74.221/SelfPatentPortal', //Live
  //  apiUrl: 'http://52.34.1.231/SelfPatentPortal', //Live
  production: true
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angtyular CLI.
